import React from 'react';
import { Trans, withI18nProps } from '@lingui/react';
import {
  FormattedMarkdown,
  formatDateForMarkdown,
} from '@qover/react-intl';
import { Policyholder } from '@qover-private/protos-web/qover/dojo/contracts/v1/policyholder';
import { Address } from '@qover-private/protos-web/qover/dojo/contracts/v1/address';

export default {
  thePolicyholder: <Trans id="general.summaryPolicyholder.title" />,
  company: (policyholder?: Policyholder) => (
    <FormattedMarkdown
      id="general.summaryPolicyholder.company"
      values={policyholder}
    />
  ),
  person: (i18n: withI18nProps['i18n'], policyholder?: Policyholder) => (
    <FormattedMarkdown
      id="general.summaryPolicyholder.person"
      values={{
        ...policyholder,
        title: i18n._({ id: `general.${policyholder?.title}` }),
        // @ts-ignore
        language: i18n._({ id: `languages.${policyholder?.language}` }),
        birthdate: policyholder?.birthdate
          ? formatDateForMarkdown(
              i18n.language,
              new Date(policyholder.birthdate),
            )
          : '',
      }}
    />
  ),
  address: (i18n: withI18nProps['i18n'], address?: Address) => (
    <FormattedMarkdown
      id="general.summaryPolicyholder.address"
      values={{
        ...address,
        country: i18n._({ id: `countries.${address?.country}` }),
      }}
    />
  ),
  companyContact: (
    i18n: withI18nProps['i18n'],
    policyholder?: Policyholder,
  ) => (
    <FormattedMarkdown
      id="general.summaryPolicyholder.companyContact"
      values={{
        ...policyholder,
        // @ts-ignore
        language: i18n._({ id: `languages.${policyholder?.language}` }),
        title: i18n._({ id: `general.${policyholder?.title}` }),
      }}
    />
  ),
  billingAddress: (i18n: withI18nProps['i18n'], address?: Address) => (
    <FormattedMarkdown
      id="general.summaryPolicyholder.billingAddress"
      values={{
        ...address,
        country: i18n._({ id: `countries.${address?.country}` }),
      }}
    />
  ),
};
